import styled from '@emotion/styled';
import {colors} from 'ui/config';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: colors.darkBrown,
  backgroundImage: 'linear-gradient(180deg, #382818 0%, #B07F51 100%)',
  paddingBottom: 130,
  paddingTop: 32,
  marginTop: 56,
});

export const Conseils = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const ConseilsTeaser = styled('div')({
  marginTop: 40,
});
